/* eslint-disable no-param-reassign */

import Vue from 'vue';
import * as Sentry from '@sentry/browser';
import User from '../models/User';

export default {
    namespaced: true,

    state: {
        token: null,
        profile: null,
        previousToken: null,
        previousProfile: null,
    },

    getters: {
        user: state => (state.profile ? new User(state.profile) : null),
        isAuthenticated: state => state.token !== null,
        isAdmin: (state, get) => (get.user ? get.user.isAdmin : false),
        isCoach: (state, get) => get.hasRole('ROLE_COACH'),
        hasRole: (state, get) => role => (get.user ? get.user.hasRole(role) : false),
        hasAnyRoles: (state, get) => roles => (get.user ? get.user.hasAnyRoles(roles) : false),

        hasPreviousUser: state => state.previousToken !== null,
        previousUser: state => (state.previousProfile ? new User(state.previousProfile) : null),
    },

    mutations: {
        setUser(state, { token, profile, storePrevious = false }) {
            state.previousToken = storePrevious ? state.token : null;
            state.previousProfile = storePrevious ? state.profile : null;

            state.token = token;
            state.profile = profile;

            if (!storePrevious) {
                Sentry.configureScope((scope) => {
                    scope.setUser(profile);
                });
            }

            Vue.http.headers.common.Authorization = `Bearer ${token}`;
        },

        setProfile(state, profile) {
            state.profile = profile;

            Sentry.configureScope((scope) => {
                scope.setUser(profile);
            });
        },

        removeUser(state) {
            state.token = null;
            state.profile = null;

            Sentry.configureScope((scope) => {
                scope.setUser(null);
            });

            delete Vue.http.headers.common.Authorization;
        },
    },

    actions: {
        async login({ commit }, { email, password }) {
            try {
                const { token } = (await Vue.http.post('login', { email, password })).body;
                const profile = (await Vue.http.get('profile', {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                })).body;

                commit('setUser', { token, profile });

                return true;
            } catch (err) {
                // TODO throw error message
                throw err;
            }
        },

        async changePassword({ state, commit }, { currentPassword, newPassword }) {
            const { token } = (await Vue.http.post('change_password', {
                currentPassword,
                newPassword,
            })).body;

            commit('setUser', {
                token,
                profile: state.profile,
            });
        },

        logout({ commit }) {
            commit('removeUser');
        },

        async switchUser({ commit }, email) {
            const response = await Vue.http.get(`profile?switch_user=${email}`);

            commit('setUser', {
                token: response.headers.get('User-JWT'),
                profile: response.body,
                storePrevious: true,
            });
        },

        async switchBack({ state, commit }) {
            commit('setUser', {
                token: state.previousToken,
                profile: state.previousProfile,
            });
        },
    },
};
